export const TYPE_FREE = 'FREE';

// Fossilizer types
export const EVIDENCE_BC_TEST = 'bitcoin:test3';
export const EVIDENCE_BATCH_FOSSILIZER = 'batchfossilizer';

// Type of references
export const REFERENCES = 'REFERENCES';
export const REFERENCED_BY = 'REFERENCED_BY';
